import React, { useEffect, useRef, useState } from "react";
import { SuperBlockContent } from "./super-block-content";

import "./rolodex.scss";
import classNames from "classnames";

interface Props {
  anchor: { current: string };
  prefix: string;
  suffix: string;
  words: string[];
  tag: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

export const Rolodex = ({ words, prefix, suffix, tag, anchor }: Props) => {
  const sorted = words.sort((a, b) => (a.length < b.length ? 1 : -1));
  const longestWord = sorted[0];
  // console.log({ sorted });
  const [prevIndex, setPrevIndex] = useState(-1);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const prevIndexRef = useRef<number>(-1);
  const currentIndexRef = useRef<number>(-1);

  const next = () => {
    let prev = currentIndexRef.current;
    let cur = prev + 1;
    if (cur > sorted.length - 1) cur = 0;
    setPrevIndex(prev);
    setCurrentIndex(cur);
    prevIndexRef.current = prev;
    currentIndexRef.current = cur;
  };

  useEffect(() => {
    setCurrentIndex(0);
    setInterval(next, 2000);
    next();
  }, []);
  return (
    <h1 className="rolodex">
      <a href={`#${anchor.current}`} aria-hidden="true" tabIndex={-1}></a>
      <span>{prefix}</span>
      {/* placeholder with longest element to provide spacing */}
      <div className="rolodex--variable--placeholder">
        <span className="rolodex--variable--placeholder--text">
          {longestWord}
        </span>
        {words.map((word, i) => (
          <span
            key={i}
            style={{ opacity: 0 }}
            className={
              "rolodex--variable--animated " +
              classNames({
                "rolodex--variable--1": currentIndex !== i && prevIndex !== i,
                "rolodex--variable--2": currentIndex === i,
                "rolodex--variable--3": prevIndex === i,
              })
            }
          >
            {word}
          </span>
        ))}
      </div>
      <span>{suffix}</span>
    </h1>
  );
};
